import { atom } from 'jotai';

export const companiesAvailableAtom = atom(false);
